var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurso27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 106.56 87.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7a662}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.67 50.69v-3.2H54.88V17.97h31.03c1.67.04 2.22-2.39.66-3.05L53.94.14a1.6 1.6 0 0 0-1.32 0L20 14.91c-1.54.69-1.04 3.07.66 3.05h31.03v29.52H30.9v3.2h2.88v2.88c0 .88.72 1.6 1.6 1.6h16.31v29.52H40.72v3.2h25.15v-3.2H54.9V55.16h16.31c.88 0 1.6-.72 1.6-1.6v-2.88h2.88ZM53.28 3.35 78.5 14.77H28.06L53.28 3.35Zm16.31 48.62H36.97v-1.28h32.62v1.28Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37 32.73v27.04H75.36c-.88 0-1.6.72-1.6 1.6v24.91h3.2V68.62h26.41v17.66h3.2V32.73h-3.2Zm-26.42 32.7v-2.46h26.41v2.46H76.95ZM31.21 59.77H3.2V32.73H0C.03 47.1-.01 72.08 0 86.28h3.2V68.62h26.41v17.66h3.2V61.36c0-.88-.72-1.6-1.6-1.6ZM3.2 62.97h26.41v2.46H3.2v-2.46Z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso27);
export default __webpack_public_path__ + "static/media/Recurso-27.82860a2904013e4c8ac02b916dcde320.svg";
export { ForwardRef as ReactComponent };